import { render, staticRenderFns } from "./SearchNavItemSelect.vue?vue&type=template&id=b0b9a1e0&scoped=true"
import script from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
export * from "./SearchNavItemSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemSelect.vue?vue&type=style&index=0&id=b0b9a1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9a1e0",
  null
  
)

export default component.exports